<div class="items-container">
  @for (item of items; track item) {
    <p-card class="content-item">
      <a
        [routerLink]="item.url"
        [queryParams]="item.queryParams"
        class="item-link"
        (click)="onMenuClick(item.url)"
      >
        <div class="item-icon-box" [style.background]="item.cardStyle?.background">
          <img
            [src]="item.icon"
            [alt]="item.title | translate"
            class="item-icon"/>
        </div>
        <span class="item-title">
          {{ item.title | translate }}
        </span>
      </a>
    </p-card>
  }
</div>
